var map = {
	"./a2.png": 627,
	"./a3.png": 522,
	"./a4.png": 293,
	"./b2.png": 374,
	"./b3.png": 367,
	"./b4.png": 752,
	"./c-left.png": 413,
	"./c2.png": 933,
	"./c3.png": 308,
	"./c4.png": 707,
	"./d-left.png": 596,
	"./d2.png": 64,
	"./d3.png": 105,
	"./d4.png": 542,
	"./e-left.png": 935,
	"./e2.png": 615,
	"./e3.png": 390,
	"./f-left.png": 62,
	"./f2.png": 418,
	"./f3.png": 419,
	"./g-left.png": 689,
	"./g1.png": 882,
	"./g2.png": 65,
	"./g3.png": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 452;